module.exports = __webpack_public_path__ + "static/media/chillBill.8b2db60c.svg";